module.exports = __webpack_public_path__ + "static/media/02.d254b5bc.jpg";